import "./chunk-7ELT755Q.mjs";

// src/web3.ts
var WEB3_PROVIDERS = [
  {
    provider: "metamask",
    strategy: "web3_metamask_signature",
    name: "MetaMask"
  },
  {
    provider: "coinbase_wallet",
    strategy: "web3_coinbase_wallet_signature",
    name: "Coinbase Wallet"
  },
  {
    provider: "okx_wallet",
    strategy: "web3_okx_wallet_signature",
    name: "OKX Wallet"
  }
];
export {
  WEB3_PROVIDERS
};
//# sourceMappingURL=web3.mjs.map